export default __webpack_public_path__ + "static/media/stool.9e7f28ab.jpg";